var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seletrr"},[_c('treeselect',{attrs:{"options":_vm.treeList,"value":_vm.value,"normalizer":_vm.normalizer},on:{"select":_vm.selectDepart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }